import { PatientReferenceIdentifier } from '@dreryk/egabinet-patient-published-language-api';
import { FirstName, LastName } from '@dreryk/person-name-common-api';

import { Translate, useTranslatedText } from '@dreryk/react-common';
import { Link, StyledFlex } from '@dreryk/react-components';

import { getPatientReferenceIdentifierTranslatableText } from '~libs.shared.patient';

import { useGoToPatientFile } from '../../common/common.hooks';
import { patientTranslationKeys } from '../../translations';

import { StyledPatientReferenceIdentifier } from './PatientCell.styled';

type PatientCellProps = {
   readonly referenceIdentifier: PatientReferenceIdentifier | undefined;
   readonly firstName: FirstName | undefined;
   readonly id: number;
   readonly lastName: LastName | undefined;
};

export const PatientCell = (props: PatientCellProps): JSX.Element => {
   const { referenceIdentifier, firstName, id, lastName } = props;
   const label = useTranslatedText(`${lastName?.asString() ?? ''} ${firstName?.asString() ?? ''}`);
   const goToPatientFile = useGoToPatientFile();

   return (
      <StyledFlex direction={'column'}>
         <Link
            testId={'openPatient'}
            label={label}
            active={false}
            onClick={() =>
               goToPatientFile(id, {
                  label: patientTranslationKeys.goBackToPatientList,
               })
            }
         />
         <StyledPatientReferenceIdentifier>
            {referenceIdentifier ? (
               <Translate>{getPatientReferenceIdentifierTranslatableText(referenceIdentifier)}</Translate>
            ) : null}
         </StyledPatientReferenceIdentifier>
      </StyledFlex>
   );
};
